import React, { useEffect, useRef, useState } from "react";
import {
  ActionIcon,
  Box,
  Button,
  Group,
  Modal,
  Select,
  SimpleGrid,
  Text,
  TextInput,
  createStyles,
  MultiSelect,
  Flex,
} from "@mantine/core";

import { IconChevronDown, IconPlus, IconTrash } from "@tabler/icons-react";
import { DatePickerInput, MonthPickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { getAllNoteTypes } from "../../services/note";
import { getAllTasks, getTaskTypes } from "../../services/task";
import { useSelector } from "react-redux";
import { createReport, editReport } from "../../services/report";
import { getMar } from "../../services";
import { getAllPatients } from "../../services/patient";
import moment from "moment";
import { Loader } from "@mantine/core";
import swal from "sweetalert";
// import SignaturePad from "signature_pad";
import { uploadFileToS3Api } from "../../utils/PresignedUrlFunction";
import { showSuccess } from "../../utils";
import TaskViewReportModal from "../../pages/Home/Task/TaskViewReportModal";
import { GoChevronDown } from "react-icons/go";
import { normalizeTaskTypes } from "../TaskReportDrawer";
import { ADL_ACTIVE_PLAN_TASK_TYPE_ID } from "../../pages/Home/Task/AddTask";
const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },
  mymodal: {
    width: 818,
    overflow: "visible",
    "& .mantine-Modal-content": {
      height: "600px !important",
    },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  reportInputFields: {
    margin: "auto",
    marginBottom: 10,
    borderBottomColor: "color-mix(in srgb, var(--app-primary) 60%, transparent)",
    borderBottomWidth: 2,
    borderBottomStyle: "solid",
    paddingBottom: 20,
    display: "flex",
    flexDirection: "row",
  },
}));

///
const ReportModal = ({ opened, onclose, title, save, ...data }) => {
  const buttonRef = useRef();
  // const signatureCanvasRef = useRef(null);
  // const signaturePadRef = useRef(null);
  const { classes } = useStyles();
  const edit = data.data ? true : false;
  const { allFacilities } = useSelector((state) => state?.facility);

  const { patients } = useSelector((state) => state.patient);
  const { allNotesTypes } = useSelector((state) => state.note);
  const { taskTypes } = useSelector((state) => state.task);

  const [noteTypeOptions, setNoteTypeOptions] = useState([]);
  const [taskTypeOptions, setTaskTypeOptions] = useState([]);

  const [generalSelect, setGeneralSelect] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);

  const [error, setError] = useState("");
  const [typeError, setTypeError] = useState("");
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const [monthValue, setMonthValue] = useState([]);
  // const [signatureTime, setSignatureTime] = useState(null);

  // Populate options based on note/task types
  useEffect(() => {
    if (allNotesTypes?.ntypes) {
      setNoteTypeOptions(
        allNotesTypes?.ntypes?.map((val) => ({
          label: val?.name,
          value: val?.id,
        })),
      );
    }
  }, [allNotesTypes?.ntypes]);

  useEffect(() => {
    if (taskTypes) {
      setTaskTypeOptions(
        taskTypes
          ?.map((val) => ({
            label: val?.name,
            value: val?.id,
          })),
      );
    }
  }, [taskTypes]);

  // Filter options based on selection
  useEffect(() => {
    if (generalSelect === "note") {
      setFilteredOptions(noteTypeOptions);
    } else if (generalSelect === "task") {
      setFilteredOptions(taskTypeOptions);
    } else {
      setFilteredOptions([]);
    }
  }, [generalSelect, noteTypeOptions, taskTypeOptions]);

  const form = useForm({
    initialValues: {
      name: "",
      startDate: null,
      endDate: null,
      periodType: "by_date",
      client: "",
      facility: "",
      taskTypes: "",
      // signature: "",
    },
    validate: {
      name: (v) => (v ? null : "Required"),
      startDate: (v) => (v ? null : "Required"),
      endDate: (v) => (v ? null : "Required"),
      // signature: (v) => (v ? null : "Required"),
    },
  });
  const fieldForm = useForm({
    initialValues: {
      source: "",
      fields: "",
    },
    validate: {
      source: (value) => (value ? null : "Required"),
      fields: (value) => (value ? null : "Required"),
    },
  });

  useEffect(() => {
    if (opened) getAllNoteTypes() && getTaskTypes() && getMar();
    if (!opened) {
      form?.reset();
      fieldForm?.clearErrors();
      form?.clearErrors();
      setFields([]);
    }
    if (opened && edit) {
      form?.setFieldValue("name", data?.data?.name);
      const { parameters } = data?.data;
      let values = parameters
        ?.filter((v) => v?.source)
        ?.map((value) => {
          return {
            id: value?._id,
            source: value?.source?.id,
            fields: value?.fields?.length ? value?.fields : ["all"],
          };
        });

      if (parameters?.length) setFields(values);
    }
  }, [opened]);

  // functions
  const onPartialSave = (values) => {
    let filtered = fields?.find((value) => value?.source === values?.source);
    const source = allNotesTypes?.ntypes?.find(
      (val) => val?.id === filtered?.source,
    );
    if (!filtered) {
      if (values?.fields?.includes("all")) {
        let tempArr =
          generalSelect === "task"
            ? {
                ...values,
                fields: [
                  "Facility Name",
                  "Task Name",
                  "Client Name",
                  "Date",
                  "Staff Name",
                  "Time",
                  "Shift",
                  "Task Completed",
                  "Activities Performed",
                  "Notes",
                ],
                id: Date.now(),
              }
            : { ...values, fields: ["all"], id: Date.now() };
        fields?.push(tempArr);
        setOptions([]);
      } else {
        fields?.push({ ...values, id: Date.now() });
        setOptions([]);
      }
      setFields(fields);
      fieldForm.setValues({
        source: true,
      });
      fieldForm.setFieldValue("fields", true);
      setOptions([]);
      setError("");
    } else {
      if (filtered?.fields === "all")
        setError(`You have already selected all fields from '${source?.name}'`);
      else setError(`You have already selected a field from '${source?.name}'`);
    }
  };

  const onSave = async () => {
    buttonRef?.current?.click();

    //  if (signaturePadRef.current?.isEmpty() && signatureTime === null) {
    //   setError("Required");
    //   return;
    // }
    setLoading(true);
    // form?.validate();
    if (!generalSelect) {
      setTypeError("Required");
      setLoading(false);
      return;
    }

    // if (signaturePadRef.current?.isEmpty()) {
    //   setError("Required");
    //   return;
    // }

    let obj;
    if (generalSelect.toLowerCase() !== "mar") {
      if (
        generalSelect.toLowerCase() === "task" &&
        form.values.periodType === "by_month"
      ) {
        if (
          form.values.client === "" ||
          !form.values.facility ||
          form.values.taskTypes === ""
        ) {
          swal({
            title: "Error",
            text: "All fields are required.",
            icon: "error",
            dangerMode: true,
          });
          setLoading(false);
          return;
        }

        obj = {
          ...form.values,
          taskTypeId: normalizeTaskTypes(form.values.taskTypes),
          // startDate: monthValue[0],
          // endDate: monthValue[1],
          reportType: generalSelect.toLowerCase(),
          parameters: fields?.map(({ fields, id, _id, ...value }) => {
            if (fields?.includes("all")) return value;
            else
              return {
                ...value,
                fields,
              };
          }),
        };
      } else {
        const { client, facility, taskTypes, periodType, ...restValues } =
          form.values;

        obj = {
          ...restValues,
          reportType: generalSelect.toLowerCase(),
          taskTypes: normalizeTaskTypes(taskTypes),
          parameters: fields?.map(({ fields, id, _id, ...value }) => {
            if (fields?.includes("all")) return value;
            else
              return {
                ...value,
                taskTypes: normalizeTaskTypes(value.source),
                fields,
              };
          }),
          // signatureTime: signatureTime,
        };
      }
    } else {
      const {
        client,
        facility,
        taskTypes,
        periodType,
        startDate,
        endDate,
        ...restValues
      } = form.values;
      obj = {
        ...restValues,
        startDate: monthValue[0],
        endDate: moment(monthValue[1]).endOf("M").toDate(),
        client: selectedClient,
        reportType: generalSelect.toLowerCase(),
        // signatureTime: signatureTime,
      };
    }

    if (edit) {
      editReport({
        ...obj,
        id: data?.data?.id,
      });
    } else {
      await createReport(obj);
      handleClose();
    }
    setLoading(false);
  };
  const handleSourceChange = (id) => {
    if (generalSelect === "note") {
      if (allNotesTypes?.ntypes) {
        let one = allNotesTypes?.ntypes?.find((value) => value?.id === id);
        let _options = one?.custom?.map((value) => ({
          label: value?.field,
          value: value?._id,
        }));
        _options?.unshift({
          label: "All",
          value: "all",
        });
        setOptions(_options);
        fieldForm.setFieldValue("fields", null);
      }
    } else {
      const taskFields = [
        "Facility Name",
        "Task Name",
        "Client Name",
        "Date",
        "Staff Name",
        "Time",
        "Shift",
        "Task Completed",
        "Activities Performed",
        "Notes",
      ];
      let _options = [
        { label: "All", value: "all" },
        ...taskFields?.map((item) => ({ label: item, value: item })),
      ];
      setOptions(_options);
      fieldForm.setFieldValue("fields", null);
    }
  };

  const getFieldOptions = (id) => {
    if (generalSelect === "note") {
      if (allNotesTypes?.ntypes) {
        let one = allNotesTypes?.ntypes?.find((value) => value?.id === id);
        let _options = one?.custom?.map((value) => ({
          label: value?.field,
          value: value?._id,
        }));
        _options?.unshift({
          label: "All",
          value: "all",
        });
        return _options;
      }
    } else {
      const taskFields = [
        "Facility Name",
        "Task Name",
        "Client Name",
        "Date",
        "Staff Name",
        "Time",
        "Shift",
        "Task Completed",
        "Activities Performed",
        "Notes",
      ];
      let _options = [
        { label: "All", value: "all" },
        ...taskFields?.map((item) => ({ label: item, value: item })),
      ];
      return _options;
    }
  };
  const removeItem = (id) => {
    setFields((p) => p?.filter((value) => value?.id !== id));
  };

  const [taskViewModalOpened, setTaskViewModalOpened] = useState(false);

  const [clientDetail, setClientDetail] = useState();
  const { allPatients } = useSelector((state) => state?.patient);

  const handleClose = () => {
    form.reset();
    fieldForm.reset();

    formTask.reset();
    setClientDetail(null);
    setTaskViewModalOpened(false);
    // setSignatureTime(null);

    form.clearErrors();
    fieldForm.clearErrors();

    setMonthValue([]);

    setError("");
    setTypeError("");
    setFields([]);
    setOptions([]);
    setNoteTypeOptions([]);
    setTaskTypeOptions([]);
    setFilteredOptions([]);
    setGeneralSelect("");

    onclose();
  };

  const formTask = useForm({
    initialValues: {
      monthValue: [],
      client: null,
      taskType: null,
    },
    validate: {
      client: (value) => (value ? null : "Client is Required"),
      taskType: (value) => (value ? null : "Task Type is Required"),
      monthValue: (value) =>
        value.length > 0 ? null : "Please select at least one month.",
    },
  });

  const handleReportClick = (value) => {
    const startOfMonth = moment(formTask.values.monthValue?.[0])
      .startOf("month")
      .toISOString();
    const endOfMonth = moment(formTask.values.monthValue?.[1])
      .endOf("month")
      .toISOString();

    if (startOfMonth === null || endOfMonth === null) {
      setError("Please select at least one month.");
      return;
    }
    getAllTasks(
      formTask.values.client,
      // clientDetail?.id,
      formTask.values.taskType,
      startOfMonth,
      endOfMonth,
    );

    setTaskViewModalOpened(true);
  };

  const handleTaskViewModalClose = () => {
    setTaskViewModalOpened(false);
    // formTask.reset();
  };

  const handleTaskClose = () => {
    form.reset();
    setClientDetail(null);
    onclose();
  };

  // ... your existing state & form code

  // useEffect(() => {
  //   if (!opened) return;

  //   // if (opened) {
  //   const canvas = signatureCanvasRef.current;
  //   if (canvas) {
  //     signaturePadRef.current?.off(); // remove old listeners
  //     // Adjust canvas size to fit container
  //     canvas.width = 400;
  //     canvas.height = 200;
  //     signaturePadRef.current = new SignaturePad(canvas, {
  //       backgroundColor: "rgba(255,255,255,0)",
  //       penColor: "rgb(0,0,0)",
  //     });
  //   }
  //   // }
  // }, [opened]);

  // useEffect(() => {
  //   if (!opened) return;

  //   const checkCanvas = () => {
  //     const canvas = signatureCanvasRef.current;

  //     if (canvas) {
  //       signaturePadRef.current?.off(); // remove old listeners
  //       canvas.width = 400;
  //       canvas.height = 200;
  //       signaturePadRef.current = new SignaturePad(canvas, {
  //         backgroundColor: "rgba(255,255,255,0)",
  //         penColor: "rgb(0,0,0)",
  //       });
  //     } else {
  //       setTimeout(checkCanvas, 50);
  //     }
  //   };

  //   checkCanvas();
  // }, [opened]);

  // const handleClearSignature = () => {
  //   signaturePadRef.current?.clear();
  // };

  // const handleSaveSignature = () => {
  //   if (signaturePadRef.current?.isEmpty()) {
  //     alert("Please provide a signature first.");
  //     return;
  //   }
  //   const dataUrl = signaturePadRef.current.toDataURL("image/png");
  //   // You can attach this to form data here
  //   // form.setFieldValue("signature", dataUrl);
  // };

  // const handleSaveSignature = async () => {
  //   if (signaturePadRef.current?.isEmpty()) {
  //     setError("Please provide a signature first.");
  //     return;
  //   }

  //   try {
  //     // Get base64 PNG from signature pad
  //     const dataUrl = signaturePadRef.current.toDataURL("image/png");

  //     // Convert base64 to Blob
  //     const res = await fetch(dataUrl);
  //     const blob = await res.blob();

  //     // Convert Blob to File
  //     const file = new File([blob], `signature_${Date.now()}.png`, {
  //       type: "image/png",
  //     });

  //     // Upload to S3
  //     const result = await uploadFileToS3Api({ file });

  //     // You now have an AWS S3 link in result.uploadURL

  //     // Optionally encrypt before saving in form
  //     // const encryptedUrl = encrypt(result.uploadURL);
  //     // form.setFieldValue("signature", encryptedUrl);

  //     // If you want raw link:
  //     form.setFieldValue("signature", result.uploadURL);
  //     form.setFieldValue("signatureTime", new Date().toISOString());
  //     setSignatureTime(new Date().toISOString());
  //     showSuccess("Signature uploaded successfully");
  //   } catch (error) {
  //     // alert("Failed to upload signature");
  //   }
  // };

  return (
    <Modal
      className={classes.mymodal}
      opened={opened}
      size={900}
      onClose={handleClose}
      shadow="md"
      overlayProps={{ blur: 3 }}
      radius={"lg"}
      zIndex={1000}
      title={
        <Group style={{ zIndex: -1 }}>
          <img src="/assets/images/addfac.png" alt="" />
          <Text ff={"Inter"} fw={600} fz={22}>
            {title}
          </Text>
        </Group>
      }
      centered
    >
      <form>
        <Select
          id="select-type"
          label="Select Type"
          placeholder="Select Task or Note"
          data={[
            { value: "task", label: "Task" },
            { value: "note", label: "Note" },
            { value: "mar", label: "MAR" },
          ]}
          size="md"
          w={{ base: "50%" }}
          value={generalSelect}
          onChange={(value) => {
            setGeneralSelect(value);
            setTypeError("");
          }}
          error={typeError}
        />
        {/* {generalSelect !== "task" && ( */}
        <TextInput
          id="report-name"
          label="Report Name*"
          pt={20}
          size="md"
          // icon={<img src="/assets/images/home2.png" alt="home" />}
          placeholder="Ex: Newman Audit"
          {...form.getInputProps("name")}
          disabled={edit ? true : false}
        />
        {/* )} */}

        {/* for task report monthly only */}
        {generalSelect === "task" ? (
          <Select
            size="sm"
            className={classes.inputField}
            withAsterisk
            label="Period Type"
            placeholder="Select Period Type"
            rightSectionPointerEvents="none"
            rightSection={<GoChevronDown color="#94A3B8" size={16} />}
            {...form.getInputProps("periodType")}
            onChange={(val) => {
              form.setFieldValue("periodType", val);
              // Clear both periods when switching type
              form.setFieldValue("monthValue", []);
              // setPeriod([]);
              // setDateRange({ type: null, date: [] });
              // setCustomError((prev) => ({ ...prev, period: "" }));
            }}
            data={[
              { value: "by_month", label: "By Month" },
              { value: "by_date", label: "By Date" },
            ]}
          />
        ) : (
          <></>
        )}

        {generalSelect === "task" && form.values.periodType === "by_month" ? (
          <>
            <Select
              size="sm"
              className={classes.inputField}
              searchable
              withAsterisk
              label="Facility"
              placeholder="Select Facility"
              rightSectionPointerEvents="none"
              rightSection={<GoChevronDown color="#94A3B8" size={16} />}
              {...form.getInputProps("facility")}
              onChange={(val) => {
                form.setFieldValue("client", "");
                form.setFieldValue("facility", val);
              }}
              data={
                allFacilities && allFacilities?.facilities
                  ? allFacilities?.facilities
                      ?.filter(({ active, deleted }) => active && !deleted)
                      ?.map((opt) => ({
                        value: opt?.id,
                        label: opt?.name,
                      }))
                  : []
              }
            />

            <Select
              searchable
              label="Client"
              disabled={!form.values.facility || !form.values.periodType}
              withAsterisk
              size="sm"
              className={classes.inputField}
              rightSection={<GoChevronDown color="#94A3B8" size={16} />}
              placeholder="Select Client"
              data={
                allPatients
                  ? allPatients
                      .filter(
                        (p) =>
                          p?.active === true &&
                          p?.deleted === false &&
                          p?.facilityId?.some(
                            (f) =>
                              f?.id === form.values.facility &&
                              f?.active === true &&
                              f?.deleted === false,
                          ),
                      )
                      .map((opt) => ({
                        value: opt?.id,
                        label: opt?.name,
                      }))
                  : []
              }
              value={form.values.client || null}
              onChange={(val) => {
                form.setFieldValue("client", val);
              }}
              error={form.errors.client}
            />

            <Box style={{ position: "relative" }}>
              <MonthPickerInput
                size="sm"
                type="range"
                allowSingleDateInRange
                label="Select Months"
                placeholder="Select Months"
                rightSection={<GoChevronDown color="#94A3B8" size={16} />}
                // {...form.getInputProps("monthValue")}
                onChange={(dates) => {
                  if (dates?.length > 1) {
                    const [start, end] = dates;
                    // Convert local PKT → UTC
                    form.setFieldValue(
                      "startDate",
                      moment(start).startOf("month").utc().toISOString(),
                    );
                    form.setFieldValue(
                      "endDate",
                      moment(end).endOf("month").utc().toISOString(),
                    );
                  }
                }}
                styles={{
                  input: {
                    paddingRight:
                      form.values.monthValue?.length > 0 ? "35px" : "12px",
                  },
                }}
              />
            </Box>

            <Select
              searchable
              label="Task Type"
              withAsterisk
              size="sm"
              className={classes.inputField}
              rightSection={<GoChevronDown color="#94A3B8" size={16} />}
              placeholder="Select Task Type"
              data={
                taskTypes
                  ? taskTypes
                      ?.map((opt) => ({
                        value: opt?.id,
                        label: opt?.name,
                      }))
                  : []
              }
              value={form.values.taskTypes || null}
              onChange={(val) => {
                form.setFieldValue("taskTypes", val);
              }}
              error={form.errors.taskTypes}
            />
          </>
        ) : (
          <></>
        )}

        {/* client list for mar report */}
        {generalSelect === "mar" && patients?.patients?.length && (
          <Select
            label="Client"
            placeholder="Select Client"
            data={patients?.patients
              ?.filter((_p) => _p?.active && !_p?.deleted)
              ?.map((patient) => {
                return { value: patient?.id, label: patient?.name };
              })}
            size="md"
            w={{ base: "100%" }}
            value={selectedClient}
            onChange={(value) => {
              setSelectedClient(value);
              setTypeError("");
            }}
            error={typeError}
          />
        )}

        <SimpleGrid
          cols={generalSelect === "mar" ? 1 : 2}
          m={"auto"}
          mt={10}
          mb={10}
        >
          {generalSelect === "mar" ? (
            <MonthPickerInput
              type="multiple"
              size="md"
              label="Select Months"
              placeholder="Select Months"
              value={monthValue}
              onChange={setMonthValue}
            />
          ) : //generalSelect === "note"
          generalSelect === "note" ||
            (generalSelect === "task" &&
              form.values.periodType === "by_date") ? (
            <DatePickerInput
              type="range"
              size="md"
              label="Start/End Date "
              placeholder="Pick dates range"
              onChange={(dates) => {
                if (dates?.length > 1) {
                  const [start, end] = dates;
                  // Convert local PKT → UTC
                  form.setFieldValue(
                    "startDate",
                    moment(start).startOf("day").utc().toISOString(),
                  );
                  form.setFieldValue(
                    "endDate",
                    moment(end).endOf("day").utc().toISOString(),
                  );
                }
              }}
            />
          ) : null}
        </SimpleGrid>
      </form>

      {
        // generalSelect !== "mar"

        !(
          generalSelect === "mar" ||
          (generalSelect === "task" && form.values.periodType !== "by_date")
        ) && (
          <>
            {fields?.map((val, index) => (
              <Box cols={2} className={classes.reportInputFields}>
                <Group grow align="flex-start">
                  <TextInput
                    disabled
                    size="md"
                    label="Number"
                    value={index + 1}
                    sx={{ marginTop: 20 }}
                  />
                  <Select
                    disabled
                    size="md"
                    searchable
                    value={val?.source}
                    data={filteredOptions}
                    sx={{ marginTop: 20 }}
                    label="Record Source*"
                    placeholder="Select Source"
                    icon={
                      <img src="/assets/images/location.png" alt="address" />
                    }
                  />
                  <MultiSelect
                    disabled
                    size="md"
                    searchable
                    label="Fields*"
                    value={val?.fields}
                    sx={{ marginTop: 20 }}
                    placeholder="Select Fields"
                    data={getFieldOptions(val?.source)}
                    icon={
                      <img src="/assets/images/location.png" alt="address" />
                    }
                  />
                </Group>
                <Group sx={{ marginTop: 40, marginLeft: 24 }}>
                  <ActionIcon
                    size={"xl"}
                    color="red"
                    variant="light"
                    onClick={() => removeItem(val?.id)}
                  >
                    <IconTrash />
                  </ActionIcon>
                </Group>
              </Box>
            ))}
            {/* {generalSelect !== "task" && ( */}
            <form
              onSubmit={fieldForm?.onSubmit((values) => onPartialSave(values))}
              className={classes.form}
            >
              <Box cols={2} className={classes.reportInputFields}>
                <Group>
                  <Select
                    searchable
                    label="Record Source*"
                    data={filteredOptions}
                    size="md"
                    icon={
                      <img src="/assets/images/location.png" alt="address" />
                    }
                    placeholder="Select Data"
                    {...fieldForm?.getInputProps("source")}
                    onChange={(value) => {
                      handleSourceChange(value);
                      fieldForm?.setFieldValue("source", value);
                    }}
                    mt={20}
                  />
                  <MultiSelect
                    searchable
                    label="Fields*"
                    size="md"
                    data={options}
                    icon={
                      <img src="/assets/images/location.png" alt="address" />
                    }
                    sx={{ marginTop: 20, minWidth: "300px" }}
                    placeholder="Select Data"
                    {...fieldForm?.getInputProps("fields")}
                  />
                </Group>

                <Group sx={{ marginTop: 42, marginLeft: 24 }}>
                  <ActionIcon
                    type="submit"
                    size={"xl"}
                    ref={buttonRef}
                    color="yellow"
                    variant="light"
                  >
                    <IconPlus />
                  </ActionIcon>
                </Group>
              </Box>
              {error != "" ? (
                <p style={{ color: "red", marginTop: 10, padding: 0 }}>
                  {error}
                </p>
              ) : (
                ""
              )}
            </form>
          </>
        )
      }
      {/* {generalSelect !== "task" && ( */}
      <SimpleGrid cols={2} mt={generalSelect === "mar" ? 50 : 0}>
        <Button
          color="yellow"
          sx={{ marginLeft: "auto", width: 122, fontFamily: "Inter" }}
          onClick={onclose}
        >
          Cancel
        </Button>
        <Button
          color="yellow"
          sx={{
            marginRight: "auto",
            width: 122,
            fontFamily: "Inter",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={onSave}
          // disabled={signatureTime === null}
          id="save-report"
        >
          {loading ? (
            <>
              <Loader color="#fff" size={20} />{" "}
              <span style={{ margin: "0 5px" }}>Save</span>
            </>
          ) : (
            "Save"
          )}
        </Button>
      </SimpleGrid>
      {/* )} */}
    </Modal>
  );
};

export default ReportModal;
